'use strict';

exports.__esModule = true;
exports.passSU = exports.LIMIT = exports.setBaseURL = exports.mockFetch = exports.fetchRequest = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _request = require('./request.js');

var last_request_start = 0;
var timeout = null;
var base_url = '';
var queue = [];
var mock = void 0;

var LIMIT = 200;

var PASS_SU = false;

function passSU(flag) {
    PASS_SU = flag;
}

function now() {
    return Date.now ? Date.now() : +new Date();
}

function parseRequest(args) {
    var payload = [];

    args.requests.forEach(function (request) {
        payload.push({
            url: request.url,
            method: request.method || 'get',
            payload: request.payload || null,
            action: request.action,
            child_request: request.child_request || null,
            use_board: !!request.use_board,
            ignore_uid: request.ignore_uid || null,
            headers: request.headers || {},
            timeout: request.timeout || null
        });
    });

    return {
        requests: payload,
        headers: args.headers,
        user_id: args.user_id,
        success: args.success,
        error: args.error
    };
}

function run(args) {
    var _args = _extends({}, args);
    delete _args.success;

    if (global.document) {
        var match = document.cookie.match(/SU=([^;]+)/);

        var su = match && match[1];

        if (PASS_SU && typeof PASS_SU == 'string') {
            _args.SU = PASS_SU;
        } else if (PASS_SU) {
            _args.SU = su;
        }
    }

    var _stop = (0, _request.doRequest)(base_url + '/_ajax/odinconcat', JSON.stringify(_args), function (data) {
        var headers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        checkQueue();
        args.success(data, headers);
    }, args.error);

    return function stop() {
        checkQueue();
        _stop();
    };
}

function startTimeout(limit) {
    clearTimeout(timeout);
    timeout = setTimeout(checkQueue, limit || LIMIT);
}

function addToQueue(args) {
    queue.push(args);
    startTimeout();
}

function checkQueue() {
    if (now() - last_request_start < LIMIT) {
        startTimeout(now() - last_request_start);
        return;
    }

    if (!queue.length) return;

    var args = queue.shift();

    run(args);
}

function fetch(args) {
    args = parseRequest(args);

    if (now() - last_request_start < LIMIT) {
        addToQueue(args);
        return function stop() {
            args.success = function () {};
        };
    }

    last_request_start = now();

    return run(args);
}

function fetchRequest(args) {
    if (mock) {
        return mock(args);
    } else {
        return fetch(args);
    }
}

function mockFetch(fn) {
    mock = fn;
}

function setBaseURL(url) {
    base_url = url;
}

exports.fetchRequest = fetchRequest;
exports.mockFetch = mockFetch;
exports.setBaseURL = setBaseURL;
exports.LIMIT = LIMIT;
exports.passSU = passSU;


//////////////////
// WEBPACK FOOTER
// ./~/@chegg/odin-concat/dist/odin_request.js
// module id = 510
// module chunks = 0